/**
 * Searches for the first tab containing the specified searchTerm in either the 'name' or 'tab-id' attribute.
 *
 * @param {HTMLElement} tabElement - The parent element containing the <ux-tab> and <ux-iws-async-tab> elements.
 * @param {string} searchTerm - The search term to look for in the 'name' and 'tab-id' attributes.
 * @returns {string | undefined} The ID of the first matching tab, or undefined if no matching tab is found.
 */
export const findTab = (tabElement, searchTerm) => {
    const tabElements = tabElement.querySelectorAll("ux-tab[name], ux-iws-async-tab[name], ux-tab[tab-id], ux-iws-async-tab[tab-id]");
    for (const tab of Array.from(tabElements)) {
        const tabName = tab.getAttribute("name");
        const tabId = tab.getAttribute("tab-id");
        if (tabName === searchTerm || tabId === searchTerm) {
            // @ts-expect-error Check for typing
            return tabId;
        }
    }
    return undefined;
};
export const findTextInTab = (tabElement, searchTerm) => {
    const tabs = tabElement.querySelectorAll("ux-tab");
    let firstTabIdWithContent;
    /* eslint-disable-next-line */
    for (let i = 0; i < tabs.length; i++) {
        const tabContent = tabs[i].textContent || tabs[i].innerText;
        const hasText = tabContent.includes(searchTerm);
        if (hasText) {
            firstTabIdWithContent = tabs[i].tabId;
            break;
        }
    }
    // @ts-expect-error Check for typing
    return firstTabIdWithContent;
};
//# sourceMappingURL=findTab.js.map
